import AdminContentLayout from '../../components/layout/AdminContentLayout'
import AdminLayout from '../../components/layout/AdminLayout'
import BaseButton from '../../components/common/BaseButton'
import '../../styles/admin/billing-box.css'
import { useNavigate } from 'react-router-dom'

const Invoice = () => {
  const navigate = useNavigate()

  const handleCancel = () => {
    navigate(-1)
  }

  return (
    <AdminLayout>
      <AdminContentLayout>
        <h2>인보이스 생성</h2>
        <div className="account-row">
          <p>수취인</p>
          <input />
        </div>
        <div className="account-row">
          <p>구독플랜</p>
          <input />
        </div>
        <div className="account-row">
          <p>메모 및 첨부파일</p>
          <textarea />
        </div>

        <div className="invoice-button-wrapper">
          <BaseButton className="invoice-button">발행</BaseButton>
          <BaseButton className="invoice-button" onClick={handleCancel}>
            취소
          </BaseButton>
        </div>
      </AdminContentLayout>
    </AdminLayout>
  )
}

export default Invoice
